import { z } from "zod";
import { MandateStatus, MandateType } from "../constants/mandate";

// Zod schemas
export const mandateStatusSchema = z.nativeEnum(MandateStatus);

export const mandateTypeSchema = z.nativeEnum(MandateType);

export const mandateSchema = z.object({
  id: z.number(),
  bank_account_id: z.number(),
  bank_name: z.string().nullable(),
  bank_ifsc: z.string(),
  bank_account_number: z.string(),
  mandate_type: mandateTypeSchema,
  mandate_limit: z.number(),
  start_date: z.string().nullable(),
  end_date: z.string().nullable(),
  registration_date: z.string().nullable(),
  approved_date: z.string().nullable(),
  date_of_upload: z.string().nullable(),
  micr_code: z.number().nullable(),
  umrn: z.string().nullable(),
  mandate_collection_type: z.string().nullable(),
  nse_member_mandate_no: z.string().nullable(),
  nse_mandate_id: z.string().nullable(),
  nse_reg_remark: z.string().nullable(),
  nse_rejection_reason: z.string().nullable(),
  status: mandateStatusSchema,
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  cancelled_at: z.string().nullable(),
  mandate_image_file: z.string().nullable(),
  nse_enach_status: z.string().nullable(),
  remark: z.string().nullable().optional(),
});

export type MandateSchema = z.infer<typeof mandateSchema>;
